/*
 * Public API Surface of ngx-loaders-css
 */

export * from './lib/ngx-loaders-css.component';
export * from './lib/ngx-loaders-css.module';
